import changeColorPointByStep from './change-color-point-by-step';

const increaseColorPointByStep = (params) => {
  const fallback = {
    rule: 'increaseColorPointByStep',
    params,
  };

  const paramsWithFallback = params.fallback ? params : { ...params, fallback };

  return changeColorPointByStep(paramsWithFallback, false);
};

export default increaseColorPointByStep;
